<template>
  <div>
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>
    <b-row v-else no-gutters>
      <b-col cols="12">
        <!-- <h6 class="w-100 text-info btn text-left">List of Students Enrolled</h6> -->
        <div id="listOfUsersEnrolled">
          <!-- Subgroup users -->
          <subgroup-users
            v-if="groupInfo.type == 'Subgroup'"
            :groupInfo="groupInfo"
          ></subgroup-users>

          <div v-else class="p-3">
            <b-overlay
              :show="loadData"
              spinner-variant="primary"
              spinner-type="grow"
              spinner-small
              rounded="md"
            >
              <div class="export text-right mb-2">
                <b-button
                  variant="success"
                  size="sm"
                  :disabled="exportCsvBtn.disabled || listOfUsersEnrolled.length == 0"
                  @click="exportToExcel('xlsx')"
                >
                  {{ exportCsvBtn.text }}
                </b-button>
              </div>

              <!-- Table stretched full width -->
              <div class="table-responsive">
                <table
                  class="table table-striped table-bordered w-100"
                  ref="groupUsers"
                >
                  <thead class="thead-dark">
                    <tr>
                      <th style="width: 30%">Name</th>
                      <th style="width: 30%">Email</th>
                      <th style="width: 25%">Phone</th>
                      <th style="width: 15%"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="listOfUsersEnrolled.length == 0">
                      <td colspan="100" class="text-center text-danger">
                        No Users enrolled Yet!
                      </td>
                    </tr>
                    <tr
                      v-else
                      v-for="(user, index) in listOfUsersEnrolled"
                      :key="index"
                    >
                      <td
                        :class="{
                          'align-middle': true,
                          'text-danger': user.enroll_status != 'active',
                        }"
                      >
                        {{ user.first_name || " " }}
                        {{ user.last_name || " " }}
                      </td>
                      <td class="align-middle">{{ user.email }}</td>
                      <td class="align-middle">{{ user.mobile }}</td>
                      <td class="align-middle text-center">
                        <span
                          class="text-danger btn p-0 m-0"
                          @click="deleteEnrolledUser(user.id, index)"
                        >
                          <i class="fas fa-trash"></i>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-overlay>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import SubgroupUsers from "./subgroup_users_edit/SubgroupUsers.vue";
import XLSX from "xlsx";

export default {
  props: ["groupInfo"],
  components: {
    subgroupUsers: SubgroupUsers,
  },
  data() {
    return {
      fetchData: false,
      loadData: false,
      listOfUsersEnrolled: [],
      mainArray: [],
      exportCsvBtn: {
        text: "Export to Excel",
        disabled: false,
      },
      deleteUserBtn: {},
      addRollNumberBtn: {},
      rollNumberAdded: false,
    };
  },
  methods: {
    async exportToExcel(type, fn, dl) {
      this.exportCsvBtn.text = "Please wait...";
      this.exportCsvBtn.disabled = true;
      var elt = this.$refs.groupUsers;
      var wb = await XLSX.utils.table_to_book(elt, { sheet: "Sheet JS" });
      this.exportCsvBtn.text = "Export to Excel";
      this.exportCsvBtn.disabled = false;
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(
            wb,
            fn || this.groupInfo.name + "_users." + (type || "xlsx")
          );
    },
    async getEnrolledSubgroupUsers() {
      let userList = this.$store.getters.getAPIKey.getEnrollSubgroupUsersList;
      const url = userList.replace("usersubgroup_id", this.groupInfo.id);

      await axios
        .get(url)
        .then((response) => {
          this.listOfUsersEnrolled = response.data.filter(
            (students) => students.pivot.usersubgrouprole_id == 2
          );
          this.listOfUsersEnrolled.forEach((user) => {
            this.deleteUserBtn[user.id] = {
              text: "",
              disabled: false,
              rollNumber: "",
              addRollNumber: false,
            };
            this.addRollNumberBtn[user.id] = {
              text: "",
              disabled: false,
            };
          });
          this.$forceUpdate();
        })
        .catch((error) => {
          error;
        });
    },
    async getEnrolledGroupUsers() {
      let userList = this.$store.getters.getAPIKey.getEnrollUsersList;
      const url = userList.replace("usergroup_id", this.groupInfo.id);

      await axios
        .get(url)
        .then((response) => {
          this.listOfUsersEnrolled = response.data;
        })
        .catch((error) => {
          error;
        });
    },
    async deleteEnrolledUser(user_id, index) {
      this.loadData = true;
      let userId = this.$store.getters.getAPIKey.deleteGroupUser;
      let url = userId.replace("usergroup_user_id", user_id);

      axios
        .delete(url)
        .then(() => {
          this.listOfUsersEnrolled.splice(index, 1);
          this.loadData = false;
        })
        .catch(() => {
          this.loadData = false;
        });
    },
  },
};
</script>

<style scoped>
#listOfUsersEnrolled {
  width: 100%;
  max-width: 100%;
}
</style>
